import { render, staticRenderFns } from "./insuredDetailInfo.vue?vue&type=template&id=2a72ab2d&scoped=true&"
import script from "./insuredDetailInfo.vue?vue&type=script&lang=js&"
export * from "./insuredDetailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a72ab2d",
  null
  
)

export default component.exports